import React from 'react'; 
import { Treemap } from '@ant-design/charts';
import { DATA } from '../../../myanfinviz'
import * as _ from 'lodash';
export const InvestingCountryTreeMap = () => {
   
 
  var newData = _.groupBy(DATA, (r) => r["Investing Country"] );
  // newData = _.orderBy(newData, (r) => r.length, "desc");
  newData = _.mapValues(newData, (r) => { 
    return {name: r[0]["Investing Country"], value: r.length}
  })
  newData = _.orderBy(newData, (r) => r.value , "desc")
  console.log("InvestingCountryTreeMap data", newData);
  var config = {
    data: {
      name: 'root',
    children: [
      ...newData
    ],
    },
    colorField: 'name',
  };

  return <Treemap {...config} />;
}